import {
    Campaign,
    CampaignDetailsData,
} from 'app/core/campaign/campaign.types';

export const campaignsData: Campaign[] = [
    {
        id: 'c1',
        title: 'Daftar & Menang',
        tagline: 'Register & Win Exciting Rewards!',
        lastUpdated: '2026-06-15T04:20:00Z',
        bannerGradient: 'from-purple-600 via-purple-500 to-pink-500',
        description: 'Earn high incentives by registering new subscribers this month.',
        quarterOptions: ['Quarter 1 (May-Jul)', 'Quarter 2 (Aug-Oct)'],
        currentQuarter: 'Quarter 1 (May-Jul)',
    },
    {
        id: 'c2',
        title: 'Menang Lagi',
        tagline: 'Keep Winning with Eastel!',
        lastUpdated: '2026-07-31T10:00:00Z',
        bannerGradient: 'from-indigo-600 via-purple-600 to-rose-500',
        description: 'Boost downline reload performance and tier up your bonuses.',
        quarterOptions: ['Quarter 1 (May-Jul)', 'Quarter 2 (Aug-Oct)'],
        currentQuarter: 'Quarter 1 (May-Jul)',
    },
    {
        id: 'c3',
        title: 'Reward Rush',
        tagline: 'Exclusive Member Loyalty Rewards',
        lastUpdated: '2026-08-01T08:00:00Z',
        bannerGradient: 'from-blue-600 via-indigo-600 to-purple-600',
        description: 'Achieve tier milestones to unlock Eastel Wallet cashbacks.',
        quarterOptions: ['Quarter 1 (May-Jul)', 'Quarter 2 (Aug-Oct)'],
        currentQuarter: 'Quarter 1 (May-Jul)',
    },
];

export const campaignDetailsDataMap: { [key: string]: CampaignDetailsData } = {
    c1: {
        campaign: campaignsData[0],
        leaderboard: [
            { rank: 1, memberId: 'E-888888', name: 'TAN AH KOW', registrations: 310 },
            { rank: 2, memberId: 'E-999999', name: 'JOHN WEAK', registrations: 120 },
            { rank: 3, memberId: 'E-777777', name: 'CHONG FEI', registrations: 220 },
            { rank: 4, memberId: 'E-123456', name: 'SITI AMINAH', registrations: 55 },
            { rank: 5, memberId: 'E-554433', name: 'RAMASAMY', registrations: 50 },
            { rank: 6, memberId: 'E-667788', name: 'KIM DASH', registrations: 48 },
            { rank: 7, memberId: 'E-991122', name: 'AHMAD ZAKI', registrations: 45 },
            { rank: 8, memberId: 'E-334455', name: 'LEONG SENG', registrations: 40 },
            { rank: 15, memberId: 'E-0068220', name: 'LEE JAYDEN', registrations: 280, isCurrentUser: true },
        ],
        userRankDetail: {
            rank: 15,
            memberId: 'E-0068220',
            name: 'LEE JAYDEN',
            phoneNumber: '601176052014',
            email: 'lee.jayden@eastel.com',
            rankCode: 'LJ',
            rankName: 'Super Master',
            status: 'ACTIVE',
            registrations: 280,
            campaignName: 'Daftar & Menang',
        },
        todayPerformance: {
            newRegistrations: 0,
            activeMembers: 0,
            incentiveEarned: 0.0,
            date: 'Friday, 31 July 2026',
        },
        progressTiers: [
            { registrations: 50, rewardAmount: 500, isUnlocked: true },
            { registrations: 100, rewardAmount: 1100, isUnlocked: true },
            { registrations: 300, rewardAmount: 3500, isUnlocked: false },
            { registrations: 500, rewardAmount: 6000, isUnlocked: false },
            { registrations: 1000, rewardAmount: 13000, isUnlocked: false },
        ],
        summaryStats: {
            monthlyRegistrations: 310,
            monthlyRegistrationsPeriod: 'June 2026',
            campaignRegistrationsCurrent: 280,
            campaignRegistrationsTarget: 300,
            campaignProgressPercent: 90,
            completeMinReloadCurrent: 280,
            completeMinReloadTarget: 310,
            completeMinReloadPercent: 91,
            notCompleteMinReloadCurrent: 30,
            notCompleteMinReloadTarget: 310,
            notCompleteMinReloadPercent: 9,
            periodDateText: 'June 2026',
        },
        notCompleteReloadMembers: [
            {
                memberId: 'E-0999999',
                name: 'JOHN WEAK A/L JOHN STRONK',
                phoneNumber: '601179764620',
                status: 'INACTIVE',
                reloadAmount: 0,
                registrationDate: '05 June 2026',
                campaignReloadDueDays: 2,
            },
            {
                memberId: 'E-0999998',
                name: 'JOHN WEAK A/L JOHN STRONK',
                phoneNumber: '601179764620',
                status: 'INACTIVE',
                reloadAmount: 0,
                registrationDate: '05 June 2026',
                campaignReloadDueDays: 2,
            },
            {
                memberId: 'E-0999997',
                name: 'JOHN WEAK A/L JOHN STRONK',
                phoneNumber: '601179764620',
                status: 'INACTIVE',
                reloadAmount: 0,
                registrationDate: '05 June 2026',
                campaignReloadDueDays: 2,
            },
            {
                memberId: 'E-0999996',
                name: 'JOHN WEAK A/L JOHN STRONK',
                phoneNumber: '601179764620',
                status: 'INACTIVE',
                reloadAmount: 0,
                registrationDate: '05 June 2026',
                campaignReloadDueDays: 2,
            },
            {
                memberId: 'E-0999995',
                name: 'JOHN WEAK A/L JOHN STRONK',
                phoneNumber: '601179764620',
                status: 'INACTIVE',
                reloadAmount: 0,
                registrationDate: '05 June 2026',
                campaignReloadDueDays: 2,
            },
            {
                memberId: 'E-0999994',
                name: 'JOHN WEAK A/L JOHN STRONK',
                phoneNumber: '601179764620',
                status: 'INACTIVE',
                reloadAmount: 0,
                registrationDate: '05 June 2026',
                campaignReloadDueDays: 2,
            },
            {
                memberId: 'E-0999993',
                name: 'JOHN WEAK A/L JOHN STRONK',
                phoneNumber: '601179764620',
                status: 'INACTIVE',
                reloadAmount: 0,
                registrationDate: '05 June 2026',
                campaignReloadDueDays: 2,
            },
            {
                memberId: 'E-0999992',
                name: 'JOHN WEAK A/L JOHN STRONK',
                phoneNumber: '601179764620',
                status: 'INACTIVE',
                reloadAmount: 0,
                registrationDate: '05 June 2026',
                campaignReloadDueDays: 2,
            },
            {
                memberId: 'E-0999991',
                name: 'JOHN WEAK A/L JOHN STRONK',
                phoneNumber: '601179764620',
                status: 'INACTIVE',
                reloadAmount: 0,
                registrationDate: '05 June 2026',
                campaignReloadDueDays: 2,
            },
            {
                memberId: 'E-0999990',
                name: 'JOHN WEAK A/L JOHN STRONK',
                phoneNumber: '601179764620',
                status: 'INACTIVE',
                reloadAmount: 0,
                registrationDate: '05 June 2026',
                campaignReloadDueDays: 2,
            },
        ],
    },
    c2: {
        campaign: campaignsData[1],
        leaderboard: [
            { rank: 1, memberId: 'E-888888', name: 'TAN AH KOW', registrations: 450 },
            { rank: 2, memberId: 'E-999999', name: 'JOHN WEAK', registrations: 320 },
            { rank: 3, memberId: 'E-777777', name: 'CHONG FEI', registrations: 290 },
            { rank: 4, memberId: 'E-123456', name: 'SITI AMINAH', registrations: 210 },
            { rank: 5, memberId: 'E-554433', name: 'RAMASAMY', registrations: 180 },
            { rank: 6, memberId: 'E-667788', name: 'KIM DASH', registrations: 150 },
            { rank: 7, memberId: 'E-991122', name: 'AHMAD ZAKI', registrations: 120 },
            { rank: 8, memberId: 'E-334455', name: 'LEONG SENG', registrations: 90 },
            { rank: 15, memberId: 'E-0068220', name: 'LEE JAYDEN', registrations: 280, isCurrentUser: true },
        ],
        userRankDetail: {
            rank: 15,
            memberId: 'E-0068220',
            name: 'LEE JAYDEN',
            phoneNumber: '601176052014',
            email: 'lee.jayden@eastel.com',
            rankCode: 'LJ',
            rankName: 'Super Master',
            status: 'ACTIVE',
            registrations: 280,
            campaignName: 'Campaign Menang Lagi',
        },
        todayPerformance: {
            newRegistrations: 2,
            activeMembers: 5,
            incentiveEarned: 150.0,
            date: 'Friday, 31 July 2026',
        },
        progressTiers: [
            { registrations: 50, rewardAmount: 500, isUnlocked: true },
            { registrations: 100, rewardAmount: 1100, isUnlocked: true },
            { registrations: 300, rewardAmount: 3500, isUnlocked: false },
            { registrations: 500, rewardAmount: 6000, isUnlocked: false },
            { registrations: 1000, rewardAmount: 13000, isUnlocked: false },
        ],
        summaryStats: {
            monthlyRegistrations: 310,
            monthlyRegistrationsPeriod: 'July 2026',
            campaignRegistrationsCurrent: 280,
            campaignRegistrationsTarget: 300,
            campaignProgressPercent: 90,
            completeMinReloadCurrent: 280,
            completeMinReloadTarget: 310,
            completeMinReloadPercent: 91,
            notCompleteMinReloadCurrent: 30,
            notCompleteMinReloadTarget: 310,
            notCompleteMinReloadPercent: 9,
            periodDateText: 'July 2026',
        },
        notCompleteReloadMembers: [
            {
                memberId: 'E-0888888',
                name: 'ALEXANDER GRAHAM',
                phoneNumber: '601234567890',
                status: 'INACTIVE',
                reloadAmount: 0,
                registrationDate: '10 July 2026',
                campaignReloadDueDays: 5,
            },
        ],
    },
    c3: {
        campaign: campaignsData[2],
        leaderboard: [
            { rank: 1, memberId: 'E-888888', name: 'TAN AH KOW', registrations: 500 },
            { rank: 2, memberId: 'E-777777', name: 'CHONG FEI', registrations: 400 },
            { rank: 3, memberId: 'E-999999', name: 'JOHN WEAK', registrations: 350 },
            { rank: 4, memberId: 'E-123456', name: 'SITI AMINAH', registrations: 250 },
            { rank: 5, memberId: 'E-554433', name: 'RAMASAMY', registrations: 210 },
            { rank: 6, memberId: 'E-667788', name: 'KIM DASH', registrations: 180 },
            { rank: 7, memberId: 'E-991122', name: 'AHMAD ZAKI', registrations: 160 },
            { rank: 8, memberId: 'E-334455', name: 'LEONG SENG', registrations: 140 },
            { rank: 9, memberId: 'E-445566', name: 'FATIMAH', registrations: 120 },
            { rank: 10, memberId: 'E-778899', name: 'DAVID TAN', registrations: 100 },
            { rank: 15, memberId: 'E-0068220', name: 'LEE JAYDEN', registrations: 280, isCurrentUser: true },
        ],
        userRankDetail: {
            rank: 15,
            memberId: 'E-0068220',
            name: 'LEE JAYDEN',
            phoneNumber: '601176052014',
            email: 'lee.jayden@eastel.com',
            rankCode: 'LJ',
            rankName: 'Super Master',
            status: 'ACTIVE',
            registrations: 280,
            campaignName: 'Reward Rush',
        },
        todayPerformance: {
            newRegistrations: 1,
            activeMembers: 3,
            incentiveEarned: 75.0,
            date: 'Friday, 31 July 2026',
        },
        progressTiers: [
            { registrations: 50, rewardAmount: 500, isUnlocked: true },
            { registrations: 100, rewardAmount: 1100, isUnlocked: true },
            { registrations: 300, rewardAmount: 3500, isUnlocked: false },
            { registrations: 500, rewardAmount: 6000, isUnlocked: false },
            { registrations: 1000, rewardAmount: 13000, isUnlocked: false },
        ],
        summaryStats: {
            monthlyRegistrations: 310,
            monthlyRegistrationsPeriod: 'August 2026',
            campaignRegistrationsCurrent: 280,
            campaignRegistrationsTarget: 300,
            campaignProgressPercent: 90,
            completeMinReloadCurrent: 280,
            completeMinReloadTarget: 310,
            completeMinReloadPercent: 91,
            notCompleteMinReloadCurrent: 30,
            notCompleteMinReloadTarget: 310,
            notCompleteMinReloadPercent: 9,
            periodDateText: 'August 2026',
        },
        notCompleteReloadMembers: [
            {
                memberId: 'E-0777777',
                name: 'KHALID ABDULLAH',
                phoneNumber: '601987654321',
                status: 'INACTIVE',
                reloadAmount: 0,
                registrationDate: '01 August 2026',
                campaignReloadDueDays: 1,
            },
        ],
    },
};
